import { QuestionBase } from '../base/question.base';
import { QuestionTypeInterface } from './question.type.interface';
import { Survey } from '../../survey';
import { ReplyItem, QuestionLevelAnswer } from '../../reply';
import { get, orderBy, keys } from 'lodash';
import { QuestionDataInterface } from '../base/questionData.interface';
import { SetOptions } from '@schoolbelle/common/object-change-tracker';
export class QuestionType extends QuestionBase
  implements QuestionTypeInterface {
  // static supportedTypes: string[] = [];

  get type() {
    return this.get(['type']) || 'base';
  }
  set type(v: string) {
    if (!this.survey.supportedQuestionTypes.includes(v))
      throw new Error(`not supported type :${v}`);
    this.onComposeDestroy(this.type);
    this.onComposeInit(v);
    this.set(['type'], v);
  }
  constructor(
    survey: Survey,
    question_id: string,
    question_type: string = 'radio'
  ) {
    super(survey, question_id);
    this.init(question_type);
  }
  /**
   *
   * @param type
   * executed within instance creation.
   * should not put any code that publish change notification system.
   */
  init(type: string) {
    this.set('type', type, { push: 'none' });
  }
  load(
    data: Partial<QuestionDataInterface> = {},
    options: SetOptions = undefined
  ) {
    //overide
    super.load({ ...data, type: this.type }, options);
  }

  onComposeInit(...args) {}
  onComposeDestroy(...args) {}
  onComposeFocus(...args) {}
  onComposeBlur(...args) {}

  prettifyAnswer(reply: ReplyItem): string {
    let quesionAnswer: QuestionLevelAnswer = get(reply.snapshot, [this.id]);
    if (quesionAnswer) {
      const option_ids = keys(quesionAnswer);
      return orderBy(
        option_ids,
        option_id => get(quesionAnswer, [option_id, 'id']),
        'asc'
      )
        .map((option_id: string) => {
          const o = this.options.find(o => o.id === option_id);
          if (o.type === 'text') {
            return get(quesionAnswer, [option_id, 'value']);
          } else {
            return o.text;
          }
        })
        .join(',');
    }
  }
}
